module.exports = __webpack_public_path__ + "static/media/web1.44384fe0.svg";